import axios from "axios";

export const GET_APPROVAL_STEP = "get_approval_step";
export const getApprovalStep = (id) => {
	const url = `/approval/steps/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_APPROVAL_STEP,
		payload: request
	};
};

export const APPROVE_STEP = "approve_step";
export const approveStep = (id) => {
	const url = `/approval/steps/${id}/approve.json`
	const request = axios.post(url);
	return {
		type: APPROVE_STEP,
		payload: request
	};
};

export const UNAPPROVE_STEP = "unapprove_step";
export const unapproveStep = (id) => {
	const url = `/approval/steps/${id}/unapprove.json`
	const request = axios.post(url);
	return {
		type: UNAPPROVE_STEP,
		payload: request
	};
};

